window.addEventListener('DOMContentLoaded', function () {
    let $sliders = document.querySelectorAll('.js-slider');

    if ($sliders.length > 0) {
        Array.from($sliders).map(function ($slider) {
            let preloadImages = $slider.getAttribute('data-preload') || false;
            let loop = $slider.getAttribute('data-loop') || false;
            let sliderOptions = {
                container: $slider,
                autoHeight: false,
                items: $slider.getAttribute('data-items') || 1,
                mode: $slider.getAttribute('data-mode') || 'carousel',
                loop:  loop,
                controls: true,
                controlsContainer: '.slider-control',
                nav: false,
                mouseDrag: true,
                autoplay: true,
                autoplayButtonOutput: false,
                autoplayTimeout: 6000,
                lazyload: true,
                speed: 600,
            };

            if ($slider.getAttribute('data-gallery')) {
                sliderOptions = {
                    ...sliderOptions,
                    gutter: 12,
                    autoplay: false,
                    //center: true,
                    loop: true,
                    items: 1,
                    responsive: {
                        640: {
                            edgePadding: 40,
                            gutter: 20
                        },
                        700: {
                            gutter: 30
                        },
                        900: {
                            items: 3
                        }
                    }
                };
            }

            let slider = tns(sliderOptions);

            if (preloadImages) {
                slider.pause();

                let images         = document.querySelectorAll('.tns-lazy-img');
                let isPreloading   = true;
                let preloadCounter = 1;

                Array.from(images).map(function (img, index) {
                    let src = img.getAttribute('data-src');
                    let preloadImg = new Image();
                    preloadImg.src = src;


                    preloadImg.addEventListener('load', function () {
                        if (images.length === preloadCounter) {
                            isPreloading = false;
                        } else {
                            preloadCounter++;
                        }
                    });

                });

                let preloadInterval = setInterval(function(){
                    preloading()
                }, 500);

                function preloading() {
                    if (false === isPreloading) {
                        stopPreloading();
                    }
                }

                function stopPreloading() {
                    clearInterval(preloadInterval);
                    slider.play();
                }
            }
        });
    }
});